import { render, staticRenderFns } from "./SetupTimeTableForClass.vue?vue&type=template&id=0e32f5d2&scoped=true"
import script from "./SetupTimeTableForClass.vue?vue&type=script&lang=js"
export * from "./SetupTimeTableForClass.vue?vue&type=script&lang=js"
import style0 from "./SetupTimeTableForClass.vue?vue&type=style&index=0&id=0e32f5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e32f5d2",
  null
  
)

export default component.exports